import ApiClient from './ApiClient';

class PaymentSettingsAPI extends ApiClient {
  constructor() {
    super('payment_settings', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, { payment_settings: data });
  }
}

export default new PaymentSettingsAPI();
